import { defineMessages } from "react-intl";

export const orderStatsMessages = defineMessages({
  totalOrders: {
    id: 'mJT+7o',
    defaultMessage: "Total Orders",
  },
  fulfilled: {
    id: 'jY+f2f',
    defaultMessage: "Fulfilled",
  },
  unfulfilled: {
    id: 'ataTev',
    defaultMessage: "Unfulfilled",
  },
});
